'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = ({name, viewClass, template, fieldOptions, methods}) => {
    return createWidgetFactory({
        name,
        viewClass,
        options: {
            '*': {
                template: Odigeo._.template(template, Odigeo.Utils.getTmplSettings()),
                name: fieldOptions.properties.name,
                dataName: fieldOptions.dataName,
                css: fieldOptions.properties.css,
                attributes: fieldOptions.properties.attributes,
                validator: fieldOptions.validator,
                requiredFieldOptional: fieldOptions.properties.requiredFieldOptional,
                requiredField: fieldOptions.requiredField,
                removeConfirmEmailEnabled: Odigeo.AB.removeConfirmEmailEnabled,
                isMobileRevamp: fieldOptions.isMobileRevamp,
                latinAlphabet: Odigeo.CreditCard.config.latinAlphabet,
            },
        },
        methods,
    });
};
